module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAM0lEQVRIx2NYJ6NBI8QwavSwMPpUVhGNEMN/moFRo4eH0bmtm2mEGBTdummERo0eFkYDAPSe0SzkjI/wAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/nl.png
// module id = 894
// module chunks = 0